import React from 'react';
function Sample() {
  return /*#__PURE__*/React.createElement("div", null, "Sample");
}
export { Sample };